@if (infraError(); as err) {
  <div class="boot-loading" role="alert" aria-live="assertive">
    <section class="boot-loading__card">
      @if (err === 'network') {
        <p>인터넷 연결 상태를 확인할 수 없습니다.<br />네트워크 연결을 확인한 뒤 다시 시도해 주세요.</p>
      } @else {
        <p>일시적인 서비스 장애로 요청을 처리하지 못했습니다.<br />잠시 후 다시 시도해 주세요.</p>
      }
      <button mat-flat-button color="primary" type="button" (click)="retry.emit()">다시 시도</button>
    </section>
  </div>
} @else {
  <!--
    <router-outlet>는 이 컴포넌트 전체에서 여기 한 곳뿐이다 — shellBare(팝업/콜백 라우트)와
    일반 라우트가 각자 독립된 <router-outlet>을 갖던 예전 앱별 hand-roll 패턴은, 부팅 중
    `shellBare` 값이 초기값→실제 라우트 데이터로 바뀌는 순간 그 두 outlet 사이를 전환하며
    "파괴 후 재생성"을 일으켰다. 이름 없는(기본) outlet 두 개가 같은 Angular Router
    outlet-context 슬롯을 공유해, 새로 생긴 outlet의 ngOnInit이 "아직 활성화 대기 중"인
    현재 라우트를 다시 활성화해버려 라우트 컴포넌트가 실제로 두 번 인스턴스화된다 —
    `sbe-sms/user-web`의 OIDC 콜백(단일 사용 code 교환)에서 이 현상이 실측됐다(2026-08-11,
    완전히 별개의 두 Request가 동일 code로 거의 동시에 발사됨). shellBare는 셸 크롬만
    `header='none'`+`renderFooter`/`renderThemeToggle`=false로 꺼서 표현하고, outlet
    자체는 라우트 전환 내내 이 하나만 계속 쓴다.

    showBootLoading()도 이 outlet을 감추거나 대체하지 않는다 — 로딩 오버레이 유무에
    상관없이 outlet은 항상 마운트돼 있고(guard가 미해결이면 outlet은 그냥 빈 상태),
    로딩 블록은 그 형제로만 추가/제거된다(2026-08-13, 전체화면 오버레이 → 콘텐츠 영역
    한정 전환 — 헤더·사이드바가 refresh API 대기 중에도 즉시 보이도록). 예전엔
    showBootLoading()이 이 분기 전체(셸 포함)를 별도 `@else if`로 대체해 헤더까지
    비어 있었다. 로딩 블록은 `[contentClass]` div **안쪽**에 outlet의 형제로 둔다(밖이
    아니다) — 앱이 contentClass를 기본값(`'contents'`) 대신 커스텀 레이아웃 클래스(특정
    패딩·flex 속성)로 넘기는 경우에도 로딩 스피너가 그 레이아웃 컨테이너를 벗어나
    정렬이 깨지지 않게 하기 위함(Gemini 리뷰 지적, 2026-08-13).
  -->
  <sbe-app-shell
    [header]="shellBare() ? 'none' : header()"
    [renderFooter]="resolvedRenderFooter()"
    [renderThemeToggle]="resolvedRenderThemeToggle()"
    [title]="title()"
    [brandLogo]="brandLogo()"
    [homeRoute]="homeRoute()"
    [navItems]="shellBare() ? [] : navItems()"
    [tabs]="tabs()"
    [hasSidenavContent]="hasSidenavContent()"
    [loggedIn]="loggedIn()"
    [footerVariant]="footerVariant()"
    [containerMaxWidthClass]="containerMaxWidthClass()"
  >
    <!--
      각 <ng-content select="[X]">를 <ng-container X>로 감싼다 — <ng-content> 태그 자신은
      원본이 projected한 [X] 어트리뷰트를 갖고 있지 않아(그 어트리뷰트는 App이 투영한
      실제 <button shellToolbarEnd> 같은 엘리먼트에만 있다), 이렇게 감싸지 않으면
      <sbe-app-shell>의 슬롯 매칭이 이 전달 지점에서 전부 실패하고 그 안쪽 catch-all
      <ng-content/>(라우트 콘텐츠 자리)로 통째로 떨어진다 — 즉 로그아웃 버튼 등 툴바
      슬롯 콘텐츠가 엉뚱하게 <main> 안 <router-outlet> 옆에 렌더된다(2026-08-11 실측,
      developer-web 마이그레이션 중 발견). <ng-container>는 자기 자신은 DOM 노드를
      추가하지 않으면서 이 어트리뷰트 기반 슬롯 매칭에는 참여한다.
    -->
    <ng-container shellToolbarStart><ng-content select="[shellToolbarStart]" /></ng-container>
    <ng-container shellToolbarContext><ng-content select="[shellToolbarContext]" /></ng-container>
    <ng-container shellToolbarActions><ng-content select="[shellToolbarActions]" /></ng-container>
    <ng-container shellToolbarEnd><ng-content select="[shellToolbarEnd]" /></ng-container>
    <ng-container shellSidenavHeader><ng-content select="[shellSidenavHeader]" /></ng-container>
    <ng-container shellSidenavContent><ng-content select="[shellSidenavContent]" /></ng-container>
    <ng-container shellBanner><ng-content select="[shellBanner]" /></ng-container>
    <!--
      이 <div>는 contentClass() 값이 무엇이든(기본값 'contents'든 앱이 넘긴 값이든)
      구조적 분기(@if/@else) 없이 항상 같은 자리에 있다 — shellBare처럼
      injectShellRouteData()발 라우트 데이터를 따라 바뀔 수 있는 값을 outlet 자체를
      감쌌다 벗겼다 하는 데 쓰면 위와 똑같은 outlet 이중 인스턴스화 버그가 재발한다.
      기본값 'contents'는 `display: contents`로 이 <div>가 박스 모델에서 빠져,
      <router-outlet>의 형제로 삽입되는 라우트 컴포넌트가 (이 래퍼가 아예 없는 것처럼)
      셸 안쪽 <main>의 직계 flex 아이템으로 남게 한다 — 앱이 자체 레이아웃 클래스가
      필요하면 `[contentClass]`로 완전히 대체해서 넘긴다.
    -->
    <div [class]="contentClass()">
      <router-outlet />
      @if (showBootLoading()) {
        <div class="content-loading" role="status" aria-live="polite">
          <mat-progress-spinner mode="indeterminate" diameter="48" />
          <p>불러오는 중…</p>
        </div>
      }
    </div>
  </sbe-app-shell>
}
